import { Icon, type IconNames } from "@atoms";

// A grey icon the size of the occupancy status icon, for the legend's entries without a status
export const InactiveLegendIcon = ({ icon }: { icon: IconNames }) => {
  return (
    <span className="flex size-6 flex-none items-center justify-center text-mapiq-black-400">
      <Icon
        icon={icon}
        size="19px"
        color="currentColor"
      />
    </span>
  );
};
